module.exports = __webpack_public_path__ + "img/7e59217.png";